module.exports = __webpack_public_path__ + "img/bg_black2.4482c554.png";